export default {
  heading: "建立密碼",
  submitHeading:"啟動教育城戶口",
  intro: "請為您新登記的教城帳戶 {id} 建立密碼以啟動帳戶。",
  submitBtn: "確定",
  resetBtn: "重設",
  closeBtn: "關閉",
  completed:
    "成功啟動教育城戶口及更新密碼。 ",
  recordNotFound: "很抱歉，您輸入的網址有誤。<br>請檢查網址連結是否正確。如需協助，請電郵至 <a href=\"mailto:support{'@'}edcity.hk\" target=\"_top\">support{'@'}edcity.hk</a>。",
  backToHome: "返回主頁",
  hasActivated: "你已利用此連結啟動教育城戶口。這連結已失效。",
  expired: "這連結已超時失效。",
  userNotFound: "啟動帳戶錯誤。 ",
};
